export default __webpack_public_path__ + "static/media/h_wdt_c_2.0ca01a33.mp3";